import { useAuth } from "~/hooks/useAuth";
import { useLists } from "~/state/lists";
import { useTaskCount } from "~/state/tasks";
import {
  allowsAlerts,
  allowsAnalytics,
  listAllowance,
  PLAN_LIMITS,
  taskAllowance,
} from "~/utils/plan-limits";
import { planTierFor } from "~/utils/onboarding";

/**
 * Counts come from the local Legend-State store rather than the server so the
 * limit UI stays accurate while offline. The database re-checks on write.
 */
export function usePlan() {
  const { user } = useAuth();
  const tier = planTierFor(user);
  const lists = useLists();
  const taskCount = useTaskCount();

  return {
    tier,
    isPro: tier === "pro",
    limits: PLAN_LIMITS[tier],
    lists: listAllowance(tier, lists.length),
    tasks: taskAllowance(tier, taskCount),
    canUseAlerts: allowsAlerts(tier),
    canUseAnalytics: allowsAnalytics(tier),
  };
}
